<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title1">First Come, First Kill</h1>
<p class="title2"><i>A Captain Heimrich Mystery</i></p>
<p class="title3">Frances and Richard Lockridge</p>
<div class="imagetit"><img alt="images" src="images/tit.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?512c8a4a